export const getMMAPreviewStyles = () => ({
  '& .new-responsive-ad-preview-container': {
    height: 500,
    wordBreak: 'break-word',

    '& .responsive-ad-preview-content': {
      top: '45%',
    },

    '& .preview-type-string': {
      bottom: 40,
    },

    '& .additional-disclaimer': {
      padding: 0,
    },

    '& .ads-label': {
      position: 'absolute',
      backgroundColor: 'white',
      color: 'black',
      fontSize: 11,
      borderRadius: 5,
      padding: '1.2px 6px 1.8px 6px',
      margin: '7px',
      opacity: '90%',
    },

    '& .multimedia-ad-wide-image': {
      '& .text-container': {
        position: 'absolute',
        left: 0,
        paddingLeft: 32,
        '& .short-headline': {
          position: 'relative',
          bottom: 15,
          fontSize: 24,
          color: 'white',
        },
        '& .final-url': {
          position: 'relative',
          bottom: 10,
          fontSize: 10,
          color: 'white',
        },
        '& .description': {
          position: 'relative',
          bottom: 5,
          fontSize: 14,
          color: 'white',
        },
        '& .action-button': {
          position: 'relative',
          borderRadius: 32,
          border: 'none',
          padding: '7px 16px 8px 16px',
          fontSize: 16,
          color: '#666',
          backgroundColor: '#EEE',
          opacity: '70%',
          fontWeight: 'bold',
        },
      },
      '& .gradient': {
        display: 'block',
        position: 'absolute',
        backgroundImage: 'linear-gradient(to left, transparent 0, black 100%)',
        height: 152,
        width: '100%',
        content: '',
      },
      '& .ads-label': {
        right: '0%',
      },
    },

    '& .multimedia-ad-landscape-image': {
      height: 'fit-content',
      '& .text-container': {
        bottom: 0,
        left: 0,
        padding: '8px 20px 20px 20px',
        lineHeight: 1.1,
        maxWidth: '-webkit-fill-available',
        width: 466,
        '& .short-headline': {
          bottom: 20,
          fontSize: 24,
          color: 'black',
          marginBottom: 8,
        },
        '& .final-url': {
          bottom: 18,
          fontSize: 10,
          color: 'green',
          marginBottom: 8,
        },
        '& .description': {
          bottom: 8,
          fontSize: 14,
          color: 'black',
          maxWidth: 250,
          paddingRight: 16,
          wordWrap: 'break-word',
        },
        '& .action-button': {
          position: 'absolute',
          bottom: 15,
          right: 15,
          borderRadius: 32,
          border: 'none',
          padding: '6px 16px 8px 16px',
          fontSize: 16,
          backgroundColor: '#a19f9d',
          color: 'white',
          opacity: '90%',
          fontWeight: 'bold',
        },
      },
    },

    '& .multimedia-ad-square-image': {
      '& .text-container': {
        position: 'absolute',
        left: 0,
        paddingLeft: 32,
        lineHeight: 1.1,
        '& .short-headline': {
          position: 'relative',
          bottom: 20,
          fontSize: 24,
          color: 'white',
        },
        '& .final-url': {
          position: 'relative',
          bottom: 18,
          fontSize: 10,
          color: 'green',
        },
        '& .description': {
          position: 'relative',
          bottom: 8,
          fontSize: 14,
          color: 'white',
        },
        '& .action-button': {
          position: 'relative',
          borderRadius: 32,
          border: 'none',
          padding: '6px 16px 8px 16px',
          fontSize: 16,
          backgroundColor: '#a19f9d',
          color: 'white',
          opacity: '90%',
          fontWeight: 'bold',
        },
      },
      '& .gradient': {
        display: 'block',
        position: 'absolute',
        backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
        height: 400,
        width: '100%',
        content: '',
      },
    },

    '& .multimedia-ad-vertical-image': {
      '& .text-container': {
        position: 'absolute',
        left: 0,
        paddingLeft: 32,
        lineHeight: 1.1,
        '& .short-headline': {
          position: 'relative',
          bottom: 20,
          fontSize: 24,
          color: 'white',
        },
        '& .final-url': {
          position: 'relative',
          bottom: 15,
          fontSize: 10,
          color: 'green',
        },
        '& .description': {
          position: 'relative',
          bottom: 5,
          fontSize: 14,
          color: 'white',
        },
        '& .action-button': {
          position: 'relative',
          top: 5,
          borderRadius: 3,
          border: 'solid 1px #dddddd',
          padding: '5px 16px 6px 16px',
          fontSize: 14,
          backgroundColor: '#a19f9d',
          color: 'white',
          opacity: '90%',
          fontWeight: 'bold',
        },
      },
      '& .gradient': {
        display: 'block',
        position: 'absolute',
        backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
        height: 400,
        width: '100%',
        content: '',
      },
    },
  },
});
